module.exports = __webpack_public_path__ + "assets/ca1d61842efdc1c45570af8aae8ba02a.mp3";